import React from 'react';
import '../styles/Header.scss'; // Nueva ruta según la estructura
import src from '../assets/Logo_white.png'
const Header = () => {
  return (
    <header className="header">
      <span className="logo">
      <img src={src} className="logo-img"/>
      </span>
      {/*<h1 className="logo">the a <br/> studio.</h1>*/}
      <ul className="sidebar">
        <li>artistic</li>
        <li>aesthetic</li>
        <li>authentic</li>
      </ul>
    </header>
  );
};

export default Header;
